//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { isDefined } from '@utils/filterPredicates';

export const getTikTokUser = (state: ICuralateStore) => state.tiktok.user.user;

export const getTikTokUserAvatarUrl = createSelector(
  getTikTokUser,
  (user) => user?.profileImage,
);

export const getTikTokUsername = createSelector(
  getTikTokUser,
  (user) => user?.username,
);

export const getTikTokUserDisplayName = createSelector(
  getTikTokUser,
  (user) => user?.displayName,
);

export const getTikTokUserId = createSelector(
  getTikTokUser,
  (user) => user?.id,
);

export const getTikTokUserFollowersCount = createSelector(
  getTikTokUser,
  (user) => user?.followersCount,
);

export const getTikTokUserIsFetchingUser = (state: ICuralateStore) =>
  state.tiktok.user.flags.isFetchingTikTokUser;

export const getFetchTikTokUserError = (state: ICuralateStore) =>
  state.tiktok.user.errors.fetchTikTokUserError;

export const getHasFetchedTikTokUser = createSelector(
  getTikTokUser,
  getTikTokUserIsFetchingUser,
  getFetchTikTokUserError,
  (user, isFetchingUser, fetchUserError) =>
    !isFetchingUser && (isDefined(user) || isDefined(fetchUserError)),
);
